import type { ReactNode } from "react";
import { Info } from "lucide-react";
import { cn } from "@web/lib/cn";

/** A quiet, warm notice: never red, never flashing. */
export function SoftBanner({
  children,
  action,
  className,
}: {
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      role="status"
      className={cn(
        "flex items-start gap-3 rounded-lg border border-note-line bg-note px-3 py-2.5 text-sm text-note-ink",
        className,
      )}
    >
      <Info aria-hidden className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">{children}</div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
